export enum TipoPedido {
    "delivery" = "delivery",
    "retirada" = "retirada",
    "mesa" = "mesa",
    "simples" = "simples"
}

export const TipoPedidoTitulo = {
    delivery: "Delivery",
    retirada: "Retirada",
    mesa: "Mesa",
    simples: "Simples"
};